import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import { AxlPanel, AxlModal } from 'axl-reactjs-ui';
import { Box, CircularProgress, TextField, MenuItem, Select, FormControl, InputLabel } from '@material-ui/core';
import _ from 'lodash';
import Slider from 'react-slick';
import moment from 'moment-timezone';
import { saveAs } from 'file-saver';
import GetAppIcon from '@material-ui/icons/GetApp';

import { AxlPagination } from '../../components/index';
import AxlSearchBox from '../../components/AxlSearchBox';
import { statusMap } from '../../constants/statusMap';
import styles, * as E from './styles';
import { GroupField, Label, Flex } from '../DispatchSearchFilter/styles';
import { openTrackingLink } from '../../utils/common';
import { colors } from '../../themes';
import { convertStatus } from '../../utils/status';
import ShipmentPODModal from '../../components/ShipmentPODModal';
import StyledAxlMultiSelect from '../../components/StyledAxlMultiSelect';
import Button from "@material-ui/core/Button";
import { ID_TYPE_OPTIONS } from '../../stores/ShipmentSearchStore';
import { generateShipmentSearchCsv, generateCsvFilename } from '../../utils/shipmentSearchCsvExport';
@inject('shipmentSearchStore', 'userStore', 'deliveryStore')
@observer
class ShipmentSearchContainer extends Component {
  constructor(props) {
    super(props);
    this.onSelectShipment = this.onSelectShipment.bind(this);
    this.onSearchEnter = this.onSearchEnter.bind(this);
    this.onSelectPage = this.onSelectPage.bind(this);

    const statusRef = {};
    const statusOptions = _.map(statusMap, function(v, k) {
      if (!statusRef[v]) {
        statusRef[v] = [k];
        return { value: v, label: v };
      } else {
        statusRef[v].push(k);
        return null;
      }
    }).filter((op) => op !== null);

    this.state = {
      searchCriteria: 'internal_id',
      query: '',
      searched: false,
      utc: false,
      localTz: moment.tz.guess(),
      order_by: 'shipment_id',
      desc: true,
      statusRef,
      statusOptions,
      showShipmentPicture: null,
      showSignaturePicture: null,
      clientProfileIds: [],
    };
  }

  componentDidMount() {
    const { userStore, deliveryStore } = this.props;
    userStore.getClientProfiles();
    deliveryStore.loadRegions();
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { userStore, shipmentSearchStore } = this.props;
    const { clientProfiles } = userStore;
    const { clientProfileIds } = prevState;
    const ids = _.map(clientProfiles, 'id');
    const { searching } = shipmentSearchStore;

    if (clientProfileIds?.length !== ids?.length && !searching) {
      this.setState({ clientProfileIds: ids });
      shipmentSearchStore.profiles = ids;
      if (!shipmentSearchStore.isBulkMode) {
        this.handleSearch(0, false);
      }
    }
  }

  handleSearch = (query, isRefresh) => {
    const { shipmentSearchStore } = this.props;

    if (isRefresh) {
      shipmentSearchStore.refreshSearch(query);
    } else {
      shipmentSearchStore.search(query);
    }
  };

  onSelectShipment = (s) => {
    let date = moment(s.dropoff_earliest_ts).format('YYYY-MM-DD');
    this.props.history.push(`/deliveries/${date}/all/${s.id}`);
  };

  onSelectPage = (p) => {
    this.handleSearch(p, false);
  };

  onSearchEnter(e) {
    this.handleSearch(this.state.query, true);
    this.setState({ searched: true });
  }

  changeSearch = (e) => {
    const value = e.target.value;
    this.setState({
      query: value,
    });
  };

  clearSearch = (e) => {
    this.setState({
      query: '',
      searched: false,
    });
    this.handleSearch('', true);
  };

  onShowShipmentModal = (shipment) => () => {
    this.setState({ showShipmentPicture: { [shipment.id]: true } });
  };

  onCloseShipmentModal = (shipment) => () => {
    this.setState({ showShipmentPicture: { [shipment.id]: false } });
  };

  onShowSignatureModal = (shipment) => () => {
    this.setState({ showSignaturePicture: { [shipment.id]: true } });
  };

  onCloseSignatureModal = (shipment) => () => {
    this.setState({ showSignaturePicture: { [shipment.id]: false } });
  };

  setRegions = (regions) => {
    const { shipmentSearchStore } = this.props;
    shipmentSearchStore.regions = regions.map((r) => r.value);
    if (shipmentSearchStore.isBulkMode) {
      shipmentSearchStore.bulkSearch(0, shipmentSearchStore.bulkSearchIds);
    } else {
      this.handleSearch(this.state.query, true);
    }
  };

  setBrands = (profiles) => {
    const { shipmentSearchStore, userStore } = this.props;
    if (profiles?.length < 1) {
      const { clientProfiles } = userStore;
      const ids = _.map(clientProfiles, 'id');
      shipmentSearchStore.profiles = ids;
    } else {
      shipmentSearchStore.profiles = profiles.map((r) => r.value);
    }
    if (shipmentSearchStore.isBulkMode) {
      shipmentSearchStore.bulkSearch(0, shipmentSearchStore.bulkSearchIds);
    } else {
      this.handleSearch(this.state.query, true);
    }
  };

  // Bulk Search Handlers
  handleSearchModeChange = (event, newMode) => {
    if (newMode !== null) {
      const { shipmentSearchStore } = this.props;
      const isBulk = newMode === 'bulk';
      shipmentSearchStore.setIsBulkMode(isBulk);
      // Clear search input and results when switching modes
      shipmentSearchStore.clearSearch();
      this.setState({ query: '', searched: false });
    }
  };

  handleBulkIdTypeChange = (event) => {
    const { shipmentSearchStore } = this.props;
    shipmentSearchStore.setBulkIdType(event.target.value);
  };

  handleBulkIdsTextChange = (event) => {
    const { shipmentSearchStore } = this.props;
    shipmentSearchStore.setBulkIdsText(event.target.value);
    // Clear warning when user modifies input
    shipmentSearchStore.setBulkLimitWarning(null);
  };

  onBulkSearchSubmit = () => {
    const { shipmentSearchStore, userStore } = this.props;
    const { clientSettings } = userStore;
    const limit = shipmentSearchStore.getBulkSearchLimit(clientSettings);
    const { ids, truncated, originalCount } = shipmentSearchStore.parseBulkIds(shipmentSearchStore.bulkIdsText, limit);

    if (truncated) {
      shipmentSearchStore.setBulkLimitWarning(
        `You entered ${originalCount} IDs, but the maximum allowed is ${limit}. Only the first ${limit} IDs will be searched.`
      );
    } else {
      shipmentSearchStore.setBulkLimitWarning(null);
    }

    // Store parsed IDs in the store for pagination
    shipmentSearchStore.setBulkSearchIds(ids);
    shipmentSearchStore.bulkSearch(0, ids);
    this.setState({ searched: true });
  };

  onSelectPageBulk = (p) => {
    const { shipmentSearchStore } = this.props;
    const { bulkSearchIds } = shipmentSearchStore;
    if (bulkSearchIds && bulkSearchIds.length > 0) {
      shipmentSearchStore.bulkSearch(p, bulkSearchIds);
    }
  };

  downloadCSV = () => {
    const { shipmentSearchStore, userStore } = this.props;
    const { results } = shipmentSearchStore;
    const statusAlias = userStore.clientSettings?.order_settings?.status_alias;

    if (!results || !results.results || results.results.length === 0) {
      return;
    }

    const csvContent = generateShipmentSearchCsv(results.results, statusAlias);
    const filename = generateCsvFilename();

    const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
    saveAs(blob, filename);
  };

  render() {
    const { shipmentSearchStore, userStore, deliveryStore } = this.props;
    const { results, regions, profiles, searching, isBulkMode, bulkIdType, bulkIdsText, bulkLimitWarning } = shipmentSearchStore;
    const { isBrandsOwner, clientProfileOptions, blurCustomerInfo, blurCustomerAddress, clientSettings } = userStore;
    const { regionList } = deliveryStore;
    const { showShipmentPicture, showSignaturePicture } = this.state;
    const settings = {
      dots: false,
      infinite: false,
      speed: 500,
      slidesToShow: 1,
      slidesToScroll: 1,
      nextArrow: <SliderNextArrow />,
      prevArrow: <SliderPrevArrow />,
    };

    let totalPage = Math.floor(results.total / results.size);
    const currentPage = results.from / results.size + 1;
    if (results.total % results.size > 0) {
      totalPage += 1;
    }
    const statusAlias = clientSettings?.order_settings?.status_alias;

    return (
      <div style={{ maxWidth: '1600px', margin: 'auto' }}>
        <div className="no-bold" style={{ display: 'flex', textAlign: 'left', marginTop: 10, alignItems: 'center' }}>
          <Flex>
            {/* Search Mode Dropdown */}
            <GroupField>
              <Label>Mode</Label>
              <FormControl variant="outlined" size="small" style={{ minWidth: 140 }}>
                <Select
                  value={isBulkMode ? 'bulk' : 'single'}
                  onChange={(e) => this.handleSearchModeChange(e, e.target.value)}
                  style={{ fontFamily: 'AvenirNext', fontSize: 14 }}
                >
                  <MenuItem value="single">Single Search</MenuItem>
                  <MenuItem value="bulk">Bulk Search</MenuItem>
                </Select>
              </FormControl>
            </GroupField>
            {isBrandsOwner && (
              <GroupField>
                <Label>{`Search for`}</Label>
                <StyledAxlMultiSelect
                  defaulValue={clientProfileOptions?.length === profiles?.length ? [] : clientProfileOptions.filter((option) => profiles.includes(option.value))}
                  placeholderButtonLabel="all brands"
                  showValues={false}
                  allowAll={true}
                  onChange={(v) => this.setBrands(v)}
                  placeholder="Search brands…"
                  options={clientProfileOptions}
                />
              </GroupField>
            )}
            <GroupField>
              <Label>{isBrandsOwner ? `in` : `Search in`}</Label>
              <StyledAxlMultiSelect
                defaulValue={regionList.filter((option) => regions.indexOf(option.value) >= 0)}
                placeholderButtonLabel="all regions"
                showValues={false}
                allowAll={true}
                onChange={(v) => this.setRegions(v)}
                placeholder="Search Regions…"
                options={regionList}
              />
            </GroupField>
          </Flex>
          {/* CSV Export Button */}
          <Button
            size="small"
            onClick={this.downloadCSV}
            variant="contained"
            color="primary"
            disabled={!results?.results?.length}
            startIcon={<GetAppIcon />}
          >
            CSV
          </Button>
        </div>

        {/* Single Search Mode */}
        {!isBulkMode && (
          <div style={{ display: 'flex', margin: '10px auto 0' }}>
            <div style={{ flex: 1 }}>
              <AxlSearchBox
                placeholder={'Search by customer name / email / address'}
                onChange={this.changeSearch}
                style={{ width: '100%', height: 'auto', flex: 1 }}
                onEnter={this.onSearchEnter}
                value={this.state.query}
                clearValue={this.clearSearch}
              />
            </div>
            <Button onClick={this.onSearchEnter} style={{ width: '160px', marginLeft: 10 }} variant="contained" color="primary" disableElevation={true}>
              Search
            </Button>
          </div>
        )}

        {/* Bulk Search Mode */}
        {isBulkMode && (
          <E.BulkSearchContainer>
            {bulkLimitWarning && (
              <E.LimitWarning>
                <E.WarningIcon>⚠️</E.WarningIcon>
                {bulkLimitWarning}
              </E.LimitWarning>
            )}
            <E.BulkSearchInputRow>
              <E.IdTypeSelectContainer>
                <FormControl variant="outlined" size="small" fullWidth>
                  <InputLabel id="bulk-id-type-label">ID Type</InputLabel>
                  <Select
                    labelId="bulk-id-type-label"
                    value={bulkIdType}
                    onChange={this.handleBulkIdTypeChange}
                    label="ID Type"
                  >
                    {ID_TYPE_OPTIONS.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </E.IdTypeSelectContainer>
              <div style={{ flex: 1, display: 'flex', flexDirection: 'column' }}>
                <E.BulkSearchTextArea
                  placeholder="Paste IDs here..."
                  value={bulkIdsText}
                  onChange={this.handleBulkIdsTextChange}
                />
                <E.BulkSearchHelperText>
                  Enter IDs separated by commas (ABC123, DEF456) or one per line. Duplicates are removed automatically.
                </E.BulkSearchHelperText>
              </div>
              <Button
                onClick={this.onBulkSearchSubmit}
                style={{ width: '160px', height: '40px', alignSelf: 'flex-start' }}
                variant="contained"
                color="primary"
                disableElevation={true}
              >
                Search
              </Button>
            </E.BulkSearchInputRow>
          </E.BulkSearchContainer>
        )}
        <E.List>
          {searching && (
            <Box style={styles.overlay}>
              <CircularProgress size={60} />
            </Box>
          )}
          <E.Table>
            <E.THead>
              <E.TR>
                <E.TH className={`left th-1`}>{`Order Info`}</E.TH>
                <E.TH className={`left th-2`}>{`Customer Info`}</E.TH>
                <E.TH className={`left th-3`}>{`Driver Info`}</E.TH>
                <E.TH className={`left th-4`}>{`Status`}</E.TH>
              </E.TR>
            </E.THead>
            <E.TBody>
              {results &&
                results.results &&
                results.results.map((result) => {
                  let stop_images = result.pod && result.pod.images ? result.pod.images : [];
                  let stop_signatures = result.pod && result.pod.signatures ? result.pod.signatures : [];
                  const { shipment, customerProfile } = result;
                  const correctedInfo = customerProfile?.corrected_address || shipment?.dropoff_address;
                  const originStreet = shipment?.dropoff_address?.street || '';
                  const originAddressLine2 = `${shipment?.dropoff_address?.city}, ${shipment?.dropoff_address?.state} ${shipment?.dropoff_address?.zipcode}`;
                  const correctedStreet = correctedInfo?.street || '';
                  const correctedAddressLine2 = `${correctedInfo?.city}, ${correctedInfo?.state} ${correctedInfo?.zipcode}`;
                  const differenceStreet = originStreet?.toLowerCase() !== correctedStreet?.toLowerCase();
                  const differenceAddressLine2 = originAddressLine2?.toLowerCase() !== correctedAddressLine2?.toLowerCase();
                  const shipmentStatus = _.defaultTo(shipment.status, '-');

                  return (
                    <E.TR key={result.shipment.id}>
                      <E.TD className={`tick`}>
                        <E.Box>
                          <AxlPanel
                            style={{
                              ...styles.panel,
                              ...{ cursor: 'pointer' },
                            }}
                            onClick={(e) => {
                              this.onSelectShipment(result.shipment);
                              e.stopPropagation();
                            }}
                          >
                            <AxlPanel.Row>
                              <AxlPanel.Col style={styles.colCenter}>
                                <E.Text className={`right`} style={blurCustomerInfo ? styles.textBlur : null}>{result.shipment.internal_id}</E.Text>
                                <E.Text className={`right`}>
                                  {moment(result.shipment.dropoff_earliest_ts).format('MM/DD/YY')} {moment(result.shipment.dropoff_earliest_ts).format('hh:mm A')} -{' '}
                                  {moment(result.shipment.dropoff_latest_ts).format('hh:mm A')}
                                </E.Text>
                              </AxlPanel.Col>
                            </AxlPanel.Row>
                          </AxlPanel>
                        </E.Box>
                      </E.TD>
                      <E.TD style={{ zIndex: 0 }}>
                        <E.Box>
                          <AxlPanel style={styles.panel}>
                            <AxlPanel.Row>
                              <AxlPanel.Col style={styles.colCenter}>
                                <E.TextBold className={`left`}>
                                  <E.Icon>
                                    <i className="fa fa-user" />
                                  </E.Icon>
                                  <E.Name className={`${blurCustomerInfo ? 'text-blur' : ''}`}>{result.shipment.customer.name}</E.Name>

                                  <E.Link style={{ float: 'right' }} onClick={() => openTrackingLink(result.shipment.tracking_code)}>
                                    {result.shipment.tracking_code}
                                  </E.Link>
                                </E.TextBold>
                                <E.TextBold className={`left`}>
                                  <E.Icon>
                                    <i className="fa fa-home" />
                                  </E.Icon>
                                  <span style={ blurCustomerAddress ? {...styles.textBlur, textDecoration:  differenceStreet ? 'line-through' : 'none'} : {textDecoration:  differenceStreet ? 'line-through' : 'none'}}>{originStreet}, </span>
                                  <span style={{ textDecoration:  differenceAddressLine2 ? 'line-through' : 'none' }}>{originAddressLine2}</span>
                                  {(differenceStreet || differenceAddressLine2) && (
                                    <div style={{ color: colors.green, marginLeft: 24 }}>
                                      <span style={blurCustomerAddress ? styles.textBlur : null}>{correctedStreet}, </span> {correctedAddressLine2}
                                    </div>
                                  )}
                                </E.TextBold>
                              </AxlPanel.Col>
                            </AxlPanel.Row>
                          </AxlPanel>
                        </E.Box>
                      </E.TD>
                      <E.TD style={{ zIndex: 0 }}>
                        <E.Box>
                          <AxlPanel style={styles.panel}>
                            <AxlPanel.Row>
                              <AxlPanel.Col style={styles.colCenter}>
                                <E.TextBold className={`left`}>
                                  <E.Icon>
                                    <i className="fa fa-user" />
                                  </E.Icon>
                                  <E.Name className={`${blurCustomerInfo ? 'text-blur' : ''}`}>{_.defaultTo(result.doc.driverName, '-')}</E.Name>
                                </E.TextBold>
                                <E.TextBold className={`left`}>
                                  <E.Icon>
                                    <i className="fa fa-phone" />
                                  </E.Icon>
                                  <E.Name className={`${blurCustomerInfo ? 'text-blur' : ''}`}>{_.defaultTo(result.driver && result.driver.phone_number, '-')}</E.Name>
                                </E.TextBold>
                              </AxlPanel.Col>
                              <AxlPanel.Col flex={0} style={{ ...styles.colCenter, ...styles.colStart }}>
                                <E.Label className={`right`}>{_.defaultTo(result.doc.label, '-')}</E.Label>
                              </AxlPanel.Col>
                            </AxlPanel.Row>
                          </AxlPanel>
                        </E.Box>
                      </E.TD>
                      <E.TD>
                        <E.Box color={_.defaultTo(styles.colorStatus[shipmentStatus], 'transparent')} className={`tick`}>
                          <AxlPanel style={styles.panel}>
                            <AxlPanel.Row>
                              <AxlPanel.Col style={styles.colCenter}>
                                <E.Text className={`left`}>
                                  <span style={{ color: _.defaultTo(styles.colorStatus[shipmentStatus], 'inherit') }}>{convertStatus(shipmentStatus, statusAlias)}</span>
                                </E.Text>
                                <E.Text className={`left`}>{result.dropoff && result.dropoff.remark ? <span>{result.dropoff.remark}</span> : '-'}</E.Text>
                              </AxlPanel.Col>
                              <AxlPanel.Col style={styles.colCenter}>
                                <E.Text className={`right`}>
                                  <span style={{ color: _.defaultTo(styles.colorStatus[shipmentStatus], 'inherit') }}>
                                    {result.dropoff && result.dropoff.actual_departure_ts ? <span>@ {moment(result.dropoff.actual_departure_ts).format('hh:mm A')}</span> : '-'}
                                  </span>
                                </E.Text>
                                <E.Text className={`right`}>
                                  <E.Button onClick={this.onShowSignatureModal(result.shipment)} style={{ opacity: stop_signatures.length > 0 ? 1 : 0.2 }}>
                                    <E.IconImage src={`assets/images/svg/edit.svg`} />
                                  </E.Button>
                                  <E.Button onClick={this.onShowShipmentModal(result.shipment)} style={{ opacity: stop_images.length > 0 ? 1 : 0.2 }}>
                                    <E.IconImage src={`assets/images/svg/camera.svg`} />
                                  </E.Button>
                                  {showSignaturePicture && showSignaturePicture[result.shipment.id] && stop_signatures.length > 0 && (
                                    <AxlModal onClose={this.onCloseSignatureModal(result.shipment)} style={styles.modalStyle} containerStyle={styles.modalContainer}>
                                      <div style={styles.wrapImages}>
                                        {stop_signatures && (
                                          <Slider {...settings}>
                                            {stop_signatures.map((img, index) => (
                                              <div style={{ height: '100%' }} key={index}>
                                                <img src={img.data} style={styles.imageShipment} />
                                              </div>
                                            ))}
                                          </Slider>
                                        )}
                                      </div>
                                    </AxlModal>
                                  )}
                                  {stop_images.length > 0 && (
                                    <ShipmentPODModal
                                      open={showShipmentPicture?.[result.shipment.id]}
                                      onClose={this.onCloseShipmentModal(result.shipment)}
                                      stop_images={stop_images}
                                      selectedStop={result.dropoff}
                                    />
                                  )}
                                </E.Text>
                              </AxlPanel.Col>
                            </AxlPanel.Row>
                          </AxlPanel>
                        </E.Box>
                      </E.TD>
                    </E.TR>
                  );
                })}
            </E.TBody>
          </E.Table>
        </E.List>
        {totalPage > 1 && (
          <div
            style={{
              maxWidth: '500px',
              marginLeft: 'auto',
              marginRight: 'auto',
              textAlign: 'center',
            }}
          >
            <AxlPagination
              onSelect={isBulkMode ? this.onSelectPageBulk : this.onSelectPage}
              current={currentPage}
              total={totalPage}
            />
          </div>
        )}
      </div>
    );
  }
}

export default ShipmentSearchContainer;

function SliderPrevArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div style={{ ...styles.arrowButton, ...styles.arrowPrev }} onClick={onClick}>
      <i style={styles.arrowIcon} className="fa fa-angle-left" />
    </div>
  );
}

function SliderNextArrow(props) {
  const { className, style, onClick } = props;
  return (
    <div style={{ ...styles.arrowButton, ...styles.arrowNext }} onClick={onClick}>
      <i style={styles.arrowIcon} className="fa fa-angle-right" />
    </div>
  );
}
